import * as React from "react"
import {useEffect, useState} from "react"
import {Autocomplete, Checkbox, TextField} from "@mui/material"
import {getSubmit} from "@ui-seeker/utils"

import {BACKEND_APIS} from "@constants"
import {createBatchFormData} from "../../@signals"


// Category taxonomy is a small static list (~32 keys) served by ia-normalizer
// via the back proxy. Load it once and filter client-side. value === label ===
// the taxonomy key (e.g. "beauty/fragrance"); no pretty mapping.
export default function CategoriesAutocomplete({...props}) {
	const [options, setOptions] = useState([])

	useEffect(() => {
		getSubmit(`${BACKEND_APIS.BATCH_ADMIN}/admin/batches/category-options`)
			.then(res => {
				const opts = res?.options || (Array.isArray(res) ? res : [])
				setOptions(opts)
			})
			.catch(err => console.error('Error fetching category options:', err))
	}, [])

	const selected = createBatchFormData.value.categories || []
	const valueObjects = selected
		.map(v => (v && typeof v === 'object') ? v : options.find(o => o.value === v) || {value: v, label: v})
		.filter(Boolean)

	return <Autocomplete
		multiple
		size="small"
		disableCloseOnSelect
		options={options}
		value={valueObjects}
		isOptionEqualToValue={(o, v) => o.value === v.value}
		getOptionLabel={(o) => o.label ?? o.value ?? ''}
		onChange={(e, newValue) => createBatchFormData.value = {
			...createBatchFormData.value,
			categories: newValue.map(o => ({value: o.value, label: o.label ?? o.value}))
		}}
		renderOption={(optProps, option, {selected: isSelected}) => (
			<li {...optProps}>
				<Checkbox size="small" style={{marginRight: 8}} checked={isSelected} />
				{option.label ?? option.value}
			</li>
		)}
		renderInput={(params) => (
			<TextField {...params} label="Categories" placeholder="Filter by category... (empty = all)" />
		)}
		{...props}
	/>
}
